import { AwsRum } from 'aws-rum-web';
import { getEnvConfigs } from './EnvConfig';
import { DOMAIN_TO_ENV } from './EnvConfigUtil';

export const createRUM = (): AwsRum | null => {
  const config = getEnvConfigs();
  const rumConfig = config?.rumConfig;

  try {
    if (!rumConfig) {
      if (!process.env.JEST_WORKER_ID) {
        console.warn('No RUM config provided for this env.');
      }
      return null;
    }

    // disable in dev desktop
    let runConfig = rumConfig.runConfig;
    const host = window.location.hostname;
    if (!DOMAIN_TO_ENV[host]) {
      // we are on dev desk, so lets disable RUM
      return null;
    }

    return new AwsRum(
      rumConfig.appConfig.APPLICATION_ID,
      rumConfig.appConfig.APPLICATION_VERSION,
      rumConfig.appConfig.APPLICATION_REGION,
      runConfig
    );
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const awsRum = createRUM();
